
<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <p class="modal-title">
        <i class="fas fa-cog mr-2"></i>
        <span class="font-weight-bold">Settings</span>
      </p>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="p-3">
        <!-- User Preferences Section -->
        <div class="row">
          <h4 class="col-4">User Preferences</h4>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label>Default Home View</label>
              <select v-model="modal.view" class="form-control form-control-sm" v-on:change="modal.change(`view`)">
                <option v-for="(o, i) in modal.options(`view`)" :key="i">
                  <span v-text="o"></span>
                </option>
              </select>
              <small class="form-text text-muted">Your default home screen </small>
            </div>
          </div>
          <div class="col"></div>
        </div>
        <hr>

        <!-- Features Section -->
        <div class="row">
          <h4 class="col-4">Features</h4>
        </div>
        <div class="row mb-3">
          <div class="col">
            <div v-for="(value, feature) in modal.features" :key="feature" class="d-flex align-items-center mb-2">
              <i class="fas mr-2" :class="value ? 'fa-check-circle text-primary' : 'fa-times-circle text-muted'"></i>
              <span>{{ formatFeatureLabel(feature) }}</span>
            </div>
          </div>
        </div>
        <hr>

        <!-- Contract Defaults Section -->
        <div class="row">
          <h4 class="col-4">Contract Defaults</h4>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label>Default Billing Type</label>
              <select v-model="modal.contractsDefault" class="form-control form-control-sm" v-on:change="modal.change(`contractsDefault`)">
                <option v-for="(option, i) in modal.options(`contractsDefault`)" :key="i" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
              <small class="form-text text-muted">Applies to new contracts</small>
            </div>
          </div>
          <div class="col"></div>
        </div>
        <hr>

        <!-- Security Section -->
        <div class="row">
          <h4 class="col-4">Security</h4>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label><strong>Multi-Factor Authentication (MFA)</strong></label>
              <small class="form-text text-muted mb-3">Add an extra layer of security to your account using an
                authenticator app (Google Authenticator, Authy, etc).</small>
              <div v-if="mfa.active">
                <div class="alert alert-success row align-items-center p-2 m-0">
                  <div class="col-auto pr-0"><i class="fas fa-lock"></i></div>
                  <div class="col">MFA is <strong>enabled</strong> on your account.</div>
                  <div class="col-auto pl-0"><button class="btn btn-sm btn-secondary" @click="disableMFA"
                      :disabled="mfa.pending">Disable</button></div>
                </div>
              </div>
              <div v-else>
                <div v-if="mfa.qr">

                  <div class="row mb-3">
                    <div class="col-6">1. Scan this QR code with your authenticator app:</div>
                    <div class="col-auto mx-auto d-block">
                      <img :src="mfa.qr" alt="MFA QR Code"
                        style="max-width:150px; border:1px solid #eee; background:#fff; padding:8px; border-radius:8px;" />
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-6">
                      <label>2. Enter the 6-digit code from your app:</label>
                    </div>
                    <div class="col-6">
                      <div class="input-group input-group-sm">
                        <input v-model="mfa.code" class="form-control text-center" maxlength="6"
                          placeholder="123456" />
                        <div class="input-group-append">
                          <button class="btn btn-outline-primary" @click="verifyMFA" :disabled="mfa.pending">
                            <span v-if="!mfa.pending">Verify</span>
                            <span v-else><i class="fas fa-spinner fa-spin"></i></span>
                          </button>
                          <button class="btn btn-sm btn-outline-danger" @click="cancelMFA"
                            :disabled="mfa.pending">Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <button class="btn btn-sm btn-primary" @click="setupMFA" :disabled="mfa.pending">Enable
                    MFA</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />

        <!-- Integrations Section -->
        <div class="row">
          <h4 class="col-4">Integrations</h4>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label><strong>Redtail CRM</strong></label>
              <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="redTailIntegrationSwitch"
                  @change="changeRedtailVars" :checked="rtUserAuthKey" :disabled="wbAuthenticated">
                <label class="custom-control-label" for="redTailIntegrationSwitch">Allow bi-directional data exchange
                  with Redtail</label>
              </div>
              <div v-if="rtShowInput" class="row pt-2">
                <div class="col-10">
                  <input type="text" class="form-control form-control-sm" placeholder="User Auth Key"
                    v-model="rtUserAuthKey">
                  <small class="form-text text-muted">Copy the UserAuthKey from Redtail Imaging and paste it
                    here</small>
                </div>
                <div class="col-2" style="padding-left: 0;">
                  <button class="btn btn-sm btn-primary" @click="saveRTUserAuthKey">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label><strong>Wealthbox CRM</strong></label>
              <div class="row align-items-center">
                <div class="col-9">
                  Allow bi-directional data exchange with Wealthbox
                </div>
                <div class="col-3 text-right">
                  <button v-show="wbAuthenticated" class="btn btn-sm btn-secondary"
                    @click="disconnectOauth">Disconnect</button>
                  <button v-show="!wbAuthenticated" :disabled="rtShowInput" class="btn btn-sm btn-primary"
                    @click="openAuthPopup">Connect</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
